module.exports = __webpack_public_path__ + "img/v1.9.f4867c20.png";